import {
  CHANGE_FOLDER_CALCULS_PAGE,
  CHANGE_FOLDER_CALCULS_SEARCH,
  CHANGE_FOLDER_CALCULS_SORT,
  CHANGE_FOLDERS_PAGE,
  CHANGE_FOLDERS_SORT,
  CLEAR_FOLDER_INFOS,
  DELETE_FOLDER,
  ENABLE_FOLDER_LOADER,
  GET_ARCHIVED_CALCULS,
  GET_FOLDER,
  LOAD_ALL_USER_FOLDERS,
  LOAD_FOLDER_CALCULS,
  LOAD_USER_FOLDERS,
  MANAGE_CALCULS_FOLDERS,
  POST_FOLDER,
  UPDATE_FOLDER,
  UPDATE_FOLDER_CALCULS_FILTERS,
  UPDATE_FOLDER_CALCULS_LIMIT,
  UPDATE_FOLDERS_LIMIT,
} from "../constants";

export function loadUserFolders() {
  return {
    type: LOAD_USER_FOLDERS,
  };
}

export function changeFoldersSort(sort) {
  return {
    type: CHANGE_FOLDERS_SORT,
    sort,
  };
}

export function changeFoldersPage(page) {
  return {
    type: CHANGE_FOLDERS_PAGE,
    page,
  };
}

export function updateFoldersLimit(limit) {
  return {
    type: UPDATE_FOLDERS_LIMIT,
    limit,
  };
}

export function enableFolderLoader() {
  return {
    type: ENABLE_FOLDER_LOADER,
  };
}

export function createFolder(folderDatas) {
  return {
    type: POST_FOLDER,
    folderDatas,
  };
}

export function updateFolder(folderDatas) {
  return {
    type: UPDATE_FOLDER,
    folderDatas,
  };
}

export function deleteFolder(folderId) {
  return {
    type: DELETE_FOLDER,
    folderId,
  };
}

export function loadAllUserFolders() {
  return {
    type: LOAD_ALL_USER_FOLDERS,
  };
}

export function manageCalculsFolders(data) {
  return {
    type: MANAGE_CALCULS_FOLDERS,
    data,
  };
}

export function changeFolderCalculsSort(sort, folderId) {
  return {
    type: CHANGE_FOLDER_CALCULS_SORT,
    sort,
    folderId,
  };
}

export function changeFolderCalculsPage(page, folderId) {
  return {
    type: CHANGE_FOLDER_CALCULS_PAGE,
    page,
    folderId,
  };
}

export function updateFolderCalculsLimit(limit, folderId) {
  return {
    type: UPDATE_FOLDER_CALCULS_LIMIT,
    limit,
    folderId,
  };
}

export function loadFolderCalculs(folderId) {
  return {
    type: LOAD_FOLDER_CALCULS,
    folderId,
  };
}

export function getFolder(folderId) {
  return {
    type: GET_FOLDER,
    folderId,
  };
}

export function getArchivedCalculs() {
  return {
    type: GET_ARCHIVED_CALCULS,
  };
}

export function changeFolderCalculsSearch(search, folderId) {
  return {
    type: CHANGE_FOLDER_CALCULS_SEARCH,
    search,
    folderId,
  };
}

export function updateFolderCalculsFilters(filters, folderId) {
  return {
    type: UPDATE_FOLDER_CALCULS_FILTERS,
    filters,
    folderId,
  };
}

export function clearFolderInfos() {
  return {
    type: CLEAR_FOLDER_INFOS,
  };
}
